import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css                  */
const LoyaltyPoint = ({ loyaltySymbol, points, view = "cart" }) => {
  const ContainerComponent = view === "usp" ? "li" : "div";
  const caption = `${points}${loyaltySymbol}`;
  const uspCaption = /* @__PURE__ */ React.createElement(Text, { variant: "caption", component: "span", className: "loyalty-point__caption" }, caption);
  const cartCaption = /* @__PURE__ */ React.createElement("span", null, caption);
  return /* @__PURE__ */ React.createElement(ContainerComponent, { className: `loyalty-point--${view}`, "data-t": "loyalty-point-component" }, /* @__PURE__ */ React.createElement("div", { className: "loyalty-point__value" }, /* @__PURE__ */ React.createElement(
    Icon,
    {
      name: "payback-card",
      className: "loyalty-point__icon",
      width: 24,
      height: 24,
      "data-t": "payback-card-icon"
    }
  ), view === "usp" ? uspCaption : cartCaption));
};
export {
  LoyaltyPoint
};
//# sourceMappingURL=LoyaltyPoint.js.map
